import { Form, Input, Radio } from 'antd';
import styled from '@emotion/styled';
import FormField from 'components/FormField';
import { useTranslate } from '@tolgee/react';
import useSmartField from 'hooks/useSmartField';
import MultipleTimePicker from '../repeatTime/MultipleTimePicker';
import EndTimeForeverPicker from '../repeatTime/EndTimeForeverPicker';
import dayjs from 'lib/dayjs';
import { usePresetTimes } from '@knowledge/knowledges/general/edit/atom/presetTime';

type TimeRangeImplProps = {
  data: Knowledge.Condition['dtScope'];
};

function TimeRangeImpl(props: TimeRangeImplProps) {
  const { data } = props;
  const isEdit = !!data.id;
  const { t } = useTranslate();
  const { data: ptdata } = usePresetTimes();

  const { field } = useSmartField('dtScope.filterCode');

  return (
    <Container>
      {isEdit && <Tip>{t('knowledge.modifyPresetTime')}</Tip>}
      <Content>
        <Form labelCol={{ span: 6 }} layout="horizontal" validateTrigger={['onSubmit']}>
          <Form.Item label={t('knowledge.时间段类型')}>
            <Radio.Group value={field.value} onChange={field.onChange}>
              <Radio value="DT_SPECIFIED"> {t('knowledge.固定时间段')} </Radio>
              <Radio value="DT_REPEAT"> {t('knowledge.循环时间段')} </Radio>
            </Radio.Group>
          </Form.Item>
          <FormField
            label={t('knowledge.时间段名称')}
            name="name"
            required
            validateTrigger={['onSubmit']}
            validate={(value) => {
              if (!value) {
                return t('knowledge.presetTimeValidateRequired');
              }
              if (!isEdit && ptdata.some((item) => item.name === value)) {
                return t('knowledge.presetTimeValidateRepeat');
              }
            }}
          >
            {({ field }) => {
              return <Input maxLength={40} value={field.value} onChange={field.onChange} />;
            }}
          </FormField>
          {field.value === 'DT_SPECIFIED' && (
            <FormField
              label={t('knowledge.起止时间')}
              name="dtScope.specifiedDtRange"
              required
              validateTrigger={['onSubmit']}
              validate={(value) => {
                const v = value?.[0];
                if (!v || !v.startAt || !v.endAt) {
                  return t('marketing.请选择起止时间');
                }
              }}
            >
              {({ field: sdtField, helpers: stdHelper }) => {
                return (
                  <EndTimeForeverPicker
                    showTime
                    required
                    value={
                      sdtField?.value?.[0]?.startAt
                        ? [
                            dayjs(sdtField?.value?.[0]?.startAt, 'YYYY-MM-DD HH:mm'),
                            dayjs(sdtField?.value?.[0]?.endAt, 'YYYY-MM-DD HH:mm'),
                          ]
                        : undefined
                    }
                    onChange={(value) => {
                      const startAt = value?.[0];
                      const endAt = value?.[1];
                      stdHelper.setValue([
                        {
                          startAt,
                          endAt,
                        },
                      ]);
                    }}
                  />
                );
              }}
            </FormField>
          )}

          {field.value === 'DT_REPEAT' && (
            <Form.Item label={t('knowledge.循环时间')} required>
              <MultipleTimePicker fieldNamePrefix="dtScope" />
            </Form.Item>
          )}
        </Form>
      </Content>
    </Container>
  );
}

const Tip = styled.div`
  color: #515359;
  font-size: 14px;
  padding: 6px 16px;
  background: #fdefef;
  line-height: 20px;
`;

const Container = styled.div``;

const Content = styled.div`
  padding: 16px 40px 16px 6px;
  background: #f7f9fa;
`;

export default TimeRangeImpl;
